import { useState } from 'react';
import { UnauthenticatedLayout } from '../layout/UnauthenticatedLayout';
import { Button, Form, Input, Spin } from 'antd';
import { CloudUploadOutlined } from '@ant-design/icons';
import type { UploadControl } from '../components/shared/PresignedUpload';
import { PresignedUpload, UploadType } from '../components/shared/PresignedUpload';
import { useStoreActions } from '../store';

export const UploadInitialData = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState<boolean>(false);
  const dispatchMessage = useStoreActions((actions) => actions.messages.dispatchMessage);
  const [uploadControl, setUploadControl] = useState<UploadControl>({
    mode: 'manual',
    startUpload: false,
  });

  const submitForm = async (vals: any) => {
    setUploadControl({ mode: 'manual', startUpload: true });
    //TODO: email validation
    form.resetFields();
  };

  return (
    <UnauthenticatedLayout>
      <Spin spinning={loading}>
        <p> Upload a file with a short description.</p>
        <Form onFinish={submitForm} layout="vertical" form={form}>
          <Form.Item
            label="Your name or your company name:"
            style={{ marginBottom: 10 }}
            name="uploaderName"
            rules={[
              {
                required: true,
                message: 'Please enter your name or your company name',
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            normalize={(value: string) => value.trim()}
            label="Your email:"
            style={{ marginBottom: 10 }}
            rules={[{ required: true, message: 'Please enter your email' }]}
            name="uploaderEmail"
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Description of file:"
            tooltip={'A short description to help identify this file.'}
            style={{ marginBottom: 10 }}
            rules={[{ required: true, message: 'Please enter a file description' }]}
            name="description"
          >
            <Input.TextArea rows={2} />
          </Form.Item>

          <Form.Item
            name="file"
            valuePropName="filelist"
            //TODO: restrict upload size and types
            // rules={[
            //   { required: true, message: 'Please select files to upload' },
            // ]}
          >
            <PresignedUpload
              dragger={true}
              uploadControl={uploadControl}
              showUpload={true}
              multipleFiles={true}
              uploadType={UploadType.INITIAL}
              tags={{
                uploaderName: form.getFieldValue('uploaderName') || '',
                description: form.getFieldValue('description') || '',
                uploaderEmail: form.getFieldValue('uploaderEmail') || '',
              }}
              loadingState={[loading, setLoading]}
              onSuccess={(result) => {
                dispatchMessage({
                  noticeType: 'success',
                  content: 'Upload successful!',
                });
              }}
              onFailure={(err) => {
                dispatchMessage({
                  noticeType: 'error',
                  content: 'Upload failed! Please try again or contact us directly.',
                });
              }}
              //TODO: validate file type and size
              //validate={async (file) => {}}
            >
              <p className="ant-upload-drag-icon">
                <CloudUploadOutlined />
              </p>
              <p className="ant-upload-text">Click or drag file to this area to upload</p>
            </PresignedUpload>
          </Form.Item>

          <Form.Item style={{ marginTop: 10, marginBottom: 0 }}>
            <Button type="primary" htmlType="submit" className="login-form-button" style={{ width: '100%' }}>
              Upload
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </UnauthenticatedLayout>
  );
};

export default UploadInitialData;
